import { createSlice, createListenerMiddleware, createSelector } from '@reduxjs/toolkit';
import { DEFAULT_THEME, IS_SERVER } from '@constants/constants';
import { type AppRootState } from '@/configureStore';

const STORAGE_KEY = '@cl/preferences';

const getInitialState = () => {
  const initialState = {
    displayTax: false,
    sector: DEFAULT_THEME
  };

  if (!IS_SERVER && localStorage?.getItem(STORAGE_KEY) !== null) {
    const storedState = JSON.parse(localStorage?.getItem(STORAGE_KEY) || ''); // Make TS stop complaining

    return {
      ...initialState,
      ...storedState
    };
  }

  return initialState;
};

export const preferencesSlice = createSlice({
  name: 'preferences',
  initialState: getInitialState,
  reducers: {
    setPreference: (state, { payload }) => {
      return {
        ...state,
        ...payload
      };
    }
  }
});

const preferencesMiddleware = createListenerMiddleware();

preferencesMiddleware.startListening({
  actionCreator: preferencesSlice.actions.setPreference,
  effect: async (action: any, listener: any) => {
    if (action.type?.indexOf('setPreference') && !IS_SERVER) {
      const state = listener.getState().preferences;
      state && localStorage?.setItem(STORAGE_KEY, JSON.stringify(state));
    }
  }
});

export const selectDisplayTax = (state: AppRootState) => state.preferences?.displayTax ?? false;
/* eslint-disable prettier/prettier */
export const selectPreference = createSelector(
  [(state: AppRootState) => state, (state: AppRootState, prefName: string) => prefName],
  (state: AppRootState, prefName: string) => {
    return state.preferences[prefName] ? state.preferences[prefName] : undefined;
  }
);

export { preferencesMiddleware };
export const { setPreference } = preferencesSlice.actions;
